import React from "react";
import MapAdd from "../components/mapView/MapAdd";
const LayoutDefault = ({ children }) => (
  <>
    <MapAdd className="center-content mt-24 pt-8 container-sm"></MapAdd>
  </>
);

export default LayoutDefault;
